import { useEffect, useState } from "react";
import is from "@sindresorhus/is";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";

import Logo from "../Logo/Logo";

import Facebook from "../../../icons/Facebook";
import Instagram from "../../../icons/Instagram";

import actions from "../../../data/actions";

const Header = props => {
  const theme = useTheme();

  const [address, setAddress] = useState();
  const [openingHours, setOpeningHours] = useState();

  const bgcolor = theme.palette.background.paper;
  const color = theme.palette.getContrastText(bgcolor);

  // (init) -> address, openingHours
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getOpeningHoursShortPost())
      .then(post => is.plainObject(post) && setOpeningHours(post.content.plain.join(", ")))
      .then(() => actions.getAddressPost())
      .then(post => is.plainObject(post) && setAddress(post.content.plain.join(", ")))
      .catch(error => console.log(error));
  }, []);

  return (
    <>
      {is.string(address) && is.string(openingHours) && (
        <Paper elevation={0} square sx={{ bgcolor, color }}>
          <Container disableGutters maxWidth="lg">
            <Grid container sx={{ p: 2 }}>
              <Grid container item xs={12} sm={12} md={6} lg={4} sx={{ alignItems: "center", justifyContent: { xs: "center", sm: "center", md: "left" } }}>
                <Logo dark width={260} sx={{ pr: 8 }} />
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ alignItems: "center", justifyContent: { xs: "center", sm: "center", md: "right", lg: "center" } }}
              >
                <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
                  <Typography component="div" variant="body2">
                    {openingHours}
                  </Typography>
                  <Typography component="div" variant="body2">
                    {address}
                  </Typography>
                </Box>
                <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
                  <Typography component="div" variant="caption">
                    {openingHours}
                  </Typography>
                  <Typography component="div" variant="caption">
                    {address}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={12}
                md={12}
                lg={2}
                sx={{ alignItems: "center", display: { xs: "none", sm: "none", md: "none", lg: "flex" }, justifyContent: "right" }}
              >
                <IconButton size="small" sx={{ pr: 1 }}>
                  <Facebook color="primary" />
                </IconButton>
                <IconButton size="small" sx={{ pr: 1 }}>
                  <Instagram color="primary" />
                </IconButton>
              </Grid>
            </Grid>
          </Container>
        </Paper>
      )}
    </>
  );
};

export default Header;
